import { cloneObject } from '../../../../../utils';
import { getFields } from '../../../../../utils/defaultFields';

const fields = [];

const schema = {
    ...cloneObject(getFields(fields)),
    especialidade: {
        id: 'especialidade',
        label: 'Especialidade',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione a especialidade',
    },
    regiao: {
        id: 'regiao',
        label: 'Região',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione a região',
    },
    localidade: {
        id: 'localidade',
        label: 'Localidade',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione a localidade',
    },
    periodoDia: {
        id: 'periodoDia',
        label: 'Período do dia',
        required: true,
        type: 'select',
        options: [],
    },
};

export default schema;
